<template>
  <section class="section section-xxl bg-default">
    <div class="container">
      <div class="row row-40 justify-content-center">
        <div class="col-sm-10 col-md-6">
          <div class="inset-xl-right-50">
            <h3>Sign Up</h3>

            <form @submit.prevent="submitForm" novalidate>
              <!-- First Name -->
              <div class="form-wrap" :class="{ 'has-error': v$.registerData.first_name.$error }">
                <input
                  v-model.trim="v$.registerData.first_name.$model"
                  id="first_name"
                  type="text"
                  class="form-input"
                />
                <label class="form-label rd-input-label" for="first_name">First Name</label>
                <span v-if="v$.registerData.first_name.$error" class="form-validation">Required</span>
              </div>

              <!-- Last Name -->
              <div class="form-wrap" :class="{ 'has-error': v$.registerData.last_name.$error }">
                <input
                  v-model.trim="v$.registerData.last_name.$model"
                  id="last_name"
                  type="text"
                  class="form-input"
                />
                <label class="form-label rd-input-label" for="last_name">Last Name</label>
                <span v-if="v$.registerData.last_name.$error" class="form-validation">Required</span>
              </div>

              <!-- Username -->
              <div class="form-wrap" :class="{ 'has-error': v$.registerData.username.$error || store.isServeError && serverError.hasOwnProperty('username') }">
                <input
                  v-model.trim="v$.registerData.username.$model"
                  id="username"
                  type="text"
                  class="form-input"
                />
                <label class="form-label rd-input-label" for="username">Username</label>
                <span v-if="v$.registerData.username.$error" class="form-validation">Required</span>
                <span v-if="store.isServeError && serverError.hasOwnProperty('username')" class="form-validation">{{ serverError.username[0] }}</span>
              </div>

              <!-- Email -->
              <div class="form-wrap" :class="{ 'has-error': v$.registerData.email.$error || store.isServeError && serverError.hasOwnProperty('email') }">
                <input
                  v-model.trim="v$.registerData.email.$model"
                  id="email"
                  type="email"
                  class="form-input"
                />
                <label class="form-label rd-input-label" for="email">Email</label>
                <span v-if="v$.registerData.email.$error" class="form-validation">
                  {{ emailErrorMsg }}
                </span>
                <span v-if="store.isServeError && serverError.hasOwnProperty('email')" class="form-validation">{{ serverError.email[0] }}</span>
              </div>

              <!-- Mobile -->
              <div class="form-wrap" :class="{ 'has-error': v$.registerData.mobile_no.$error || store.isServeError && serverError.hasOwnProperty('mobile_no') }">
                <input
                  v-model.trim="v$.registerData.mobile_no.$model"
                  id="mobile_no"
                  type="text"
                  class="form-input"
                />
                <label class="form-label rd-input-label" for="mobile_no">Mobile No.</label>
                <span v-if="v$.registerData.mobile_no.$error" class="form-validation">
                  Must be 10 digits
                </span>
                <span v-if="store.isServeError && serverError.hasOwnProperty('mobile_no')" class="form-validation">{{ serverError.mobile_no[0] }}</span>
              </div>

              <!-- Password -->
              <div class="form-wrap" :class="{ 'has-error': v$.registerData.password.$error || store.isServeError && serverError.hasOwnProperty('password') }" style="position: relative;">
                <input
                  v-model.trim="v$.registerData.password.$model"
                  id="password"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-input"
                  style="padding-right: 40px;"
                />
                <label class="form-label rd-input-label" for="password">Password</label>
                <span @click="showPassword = !showPassword" style="position: absolute; right: 15px; top: 15px; cursor: pointer; z-index: 10; font-size: 1.2em; color: #a0a0a0;">
                   <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </span>
                <span v-if="v$.registerData.password.$error" class="form-validation">
                  Min 8 characters
                </span>
                <span v-if="store.isServeError && serverError.hasOwnProperty('password')" class="form-validation">{{ serverError.password[0] }}</span>
              </div>

              <!-- Confirm Password -->
              <div
                class="form-wrap"
                :class="{ 'has-error': v$.registerData.password_confirmation.$error }"
                style="position: relative;"
              >
                <input
                  v-model.trim="v$.registerData.password_confirmation.$model"
                  id="password_confirmation"
                  :type="showPasswordConfirmation ? 'text' : 'password'"
                  class="form-input"
                  style="padding-right: 40px;"
                />
                <label class="form-label rd-input-label" for="password_confirmation">
                  Confirm Password
                </label>
                <span @click="showPasswordConfirmation = !showPasswordConfirmation" style="position: absolute; right: 15px; top: 15px; cursor: pointer; z-index: 10; font-size: 1.2em; color: #a0a0a0;">
                   <i :class="showPasswordConfirmation ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </span>
                <span v-if="v$.registerData.password_confirmation.$error" class="form-validation">
                  Passwords must match
                </span>
              </div>

              <!-- Terms Checkbox -->
              <!-- <label class="checkbox-inline">
                <input
                  type="checkbox"
                  v-model="v$.registerData.terms.$model"
                  class="checkbox-custom"
                />
                <span class="checkbox-custom-dummy"></span>
                I accept the Terms & Conditions
                <span v-if="v$.registerData.terms.$error" class="form-validation d-block">
                  You must accept Terms & Conditions
                </span>
              </label> -->

              <div class="group-sm group-middle group-button-1 mt-3">
                <button class="button button-lg button-primary button-zakaria" type="submit" :disabled="isSubmitting">
                  <span v-if="isSubmitting">Submitting...</span>
                  <span v-else>Sign Up</span>
                </button>
              </div>

              <p v-if="errorMessage" class="text-danger mt-3">{{ errorMessage }}</p>
              <p v-if="successMessage" class="text-success mt-3">{{ successMessage }}</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { computed, onMounted, ref } from 'vue'
import { useHead } from '@unhead/vue'
import { useCartStore } from '@/stores/cart'
import useVuelidate from '@vuelidate/core'
import { required, email, sameAs, minLength, numeric } from '@vuelidate/validators'
import { useAuthStore } from '@/stores/authStore'
import { storeToRefs } from 'pinia'

const store = useAuthStore()
const { registerData, isSubmitting, successMessage, errorMessage, serverError } = storeToRefs(store)

const showPassword = ref(false)
const showPasswordConfirmation = ref(false)

const cartStore = useCartStore()

// create a reactive computed reference for password
const passwordRef = computed(() => registerData.value.password)

const rules = {
  registerData: {
    first_name: { required },
    last_name: { required },
    username: { required },
    email: { required, email },
    mobile_no: { required, numeric, minLength: minLength(10) },
    password: { required, minLength: minLength(8) },
    password_confirmation: { required,  sameAsPassword: sameAs(passwordRef, 'Passwords must match') },
    // terms: { required: helpers.withMessage('You must accept terms', v => v === true) },
  },
}

const v$ = useVuelidate(rules, { registerData })

const emailErrorMsg = computed(() => {
  if (!v$.value.registerData.email.$dirty) return ''
  if (!v$.value.registerData.email.required) return 'Required'
  if (!v$.value.registerData.email.email) return 'Invalid email format'
  return ''
})

async function submitForm() {
  v$.value.$touch()
  if (v$.value.$invalid) {
    errorMessage.value = 'Please fix the form errors before submitting.'
    return
  }
  store.register()  
}


useHead({
  title: 'CakeGurus - Sign Up',
  meta: [{ name: 'description', content: 'Sign up for CakeGurus.' }],
})

onMounted(async () => {
  cartStore.loadCart()

  const scriptId = 'script-js-script'

   // Check if the script already exists
   const existingScript = document.getElementById(scriptId)

   if (existingScript) {
      // Replace it: remove and re-add
      existingScript.remove()
   }

   // Create and append a fresh script
   const newScript = document.createElement('script')
   newScript.src = '/assets/js/script.js'
   newScript.id = scriptId
   document.body.appendChild(newScript)   
})
</script>

<style scoped>
.has-error .form-input {
  border-color: #e74c3c !important;
}
.form-validation {
  color: #e74c3c;
  font-size: 13px;
}
.text-success {
  color: #2ecc71;
}
.text-danger {
  color: #e74c3c;
}
</style>
